<template>
  <JoszakiModal
    :open="isOpen"
    :title="$t('emailExistsModal.title')"
    @cancel="isOpen = false"
    @close="isOpen = false"
  >
    <template #body>
      <JoszakiLoading :active="isSending" />
      <p class="text-xl text-left md:text-center">
        {{ $t("emailExistsModal.thisEmail") }}
      </p>
      <p class="text-3xl bg-whitesmoke text-center align-middle py-4">
        {{ email }}
      </p>
      <p class="text-xl text-left md:text-center">
        {{ $t("emailExistsModal.alreadyRegistered") }}
      </p>
      <p>
        {{ $t("emailExistsModal.loginOrResetPassword") }}
      </p>
    </template>

    <template #footer>
      <div class="w-full flex justify-between">
        <JoszakiButton type="info" :inverted="true" @click="onSend"
          ><span class="font-bold">{{
            $t("emailExistsModal.sendPasswordRecovery")
          }}</span></JoszakiButton
        >
        <JoszakiButton type="success" :to="localePath({ name: 'login' })">
          {{ $t("emailExistsModal.login") }}
        </JoszakiButton>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import { ref, useContext, useRouter } from "@nuxtjs/composition-api";
import { useRegistration } from "./useRegistration";
import { useSendPasswordRecovery } from "~/components/_refactored/auth";

export default {
  setup() {
    const { $logger, localePath } = useContext();
    const router = useRouter();
    const { email } = useRegistration();
    const isOpen = ref(false);
    const isSending = ref(false);

    const sendPasswordRecovery = useSendPasswordRecovery();

    const open = () => {
      isOpen.value = true;
    };

    async function onSend() {
      try {
        isSending.value = true;
        await sendPasswordRecovery({ email: email.value });
        isOpen.value = false;
        setTimeout(() => {
          router.push(localePath({ name: "login" }));
        }, 3000);
      } catch (error) {
        $logger.error(error);
      } finally {
        isSending.value = false;
      }
    }

    return {
      isOpen,
      open,
      email,
      onSend,
      isSending,
    };
  },
};
</script>
